import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["textContent"]

import {computed} from "vue";
import Icon from "../Icon/Icon.vue";

interface Props {
  counter: number;
  title: string;
  mode: StepMode;
}

export type StepMode = 'previous'|'current'|'next';

interface Emit {
  (event: 'select'): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Step',
  props: {
    counter: {},
    title: {},
    mode: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function select(): void {
  emit('select');
}

const iconClass = computed(() => {
  if (props.mode === 'next') {
    return 'text-neutral2-500 bg-neutral2-200';
  }
  return 'text-white bg-green-500';
});

const titleClass = computed(() => {
  if (props.mode === 'current') {
    return 'font-semibold';
  }
  return '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-center",
    onClick: select
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["size-8 flex-shrink-0 rounded-lg mr-3 flex items-center justify-center font-semibold", iconClass.value])
    }, [
      (_ctx.mode==='previous')
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            name: "jobOfferStepperStepFinished"
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(props.counter), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
    ], 2 /* CLASS */),
    _createElementVNode("span", {
      class: _normalizeClass(titleClass.value),
      textContent: _toDisplayString(props.title)
    }, null, 10 /* CLASS, PROPS */, _hoisted_1)
  ]))
}
}

})